export default "__VITE_ASSET__DEkDKh2C__"